/**
 * Handles keyup event.
 * @param {KeyboardEvent} event The event object.
 */
const handleKeyUp = ( event ) => {

	if ( event.code === 'Tab' ) {

		handleTabPress( event );

	}

};

/**
 * Adds keyboard interaction classes.
 * @param {KeyboardEvent} event The event object.
 */
const handleTabPress = ( event ) => {

	document.body.classList.add( 'using-keyboard' );
	if ( event.target.classList.contains( 'tab' ) ) {

		document.body.classList.add( 'using-keyboard-tab' );

	}

};
/**
 * Handles mouse movement or click to remove keyboard-specific classes.
 */
const handleMouseUse = () => {

	document.body.classList.remove( 'using-keyboard', 'using-keyboard-tab' );

};

/**
 * Initializes tab key handling.
 */
const tabHandler = () => {

	document.body.addEventListener( 'keyup', handleKeyUp );
	document.addEventListener( 'mousedown', handleMouseUse );

};

export { tabHandler };
